<script>

import { Overlay } from '../../'

export default {
    name: 'AcceleratorOscillator',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Accelerator Oscillator - Shows acceleration/deceleration of AO',
                preset: {
                    name: 'AC',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#2196f3'
                    }
                }
            }
        },
        use_for() { return ['AcceleratorOscillator'] },
        calc() {
            return {
                props: {},
                conf: { renderer: 'Histogram' },
                update: `
                    let median = ts((high[0] + low[0]) / 2)
                    let ao = ts(sma(median, 5)[0] - sma(median, 34)[0])
                    return ao[0] - sma(ao, 5)[0]
                `
            }
        }
    }
}
</script>
